import { render, staticRenderFns } from "./searchRelatorio.vue?vue&type=template&id=64c5812e&scoped=true"
import script from "./searchRelatorio.vue?vue&type=script&lang=js"
export * from "./searchRelatorio.vue?vue&type=script&lang=js"
import style0 from "./searchRelatorio.vue?vue&type=style&index=0&id=64c5812e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5812e",
  null
  
)

export default component.exports